<template>
  <div v-if="!isYoshinFuka" class="content">
    <section>
      <div class="page-btn-wrapper">
        <md-button
          type="button"
          class="btn-lg btn-success base-btn col-10 col-md-3 mx-lg-4"
          :to="{ name: 'OrderTransport', params: { yusoKbn: 0 } }"
        >
          通常輸送
        </md-button>
        <md-button
          type="button"
          class="btn-lg btn-success base-btn col-10 col-md-3 mx-lg-4"
          :to="{ name: 'OrderMeihenTransport', params: { yusoKbn: 1 } }"
        >
          名変輸送
        </md-button>
      </div>
    </section>
  </div>
</template>
<script>
import Navi from './Navi'
import Mixin from '../mixin/Mixin'
export default {
  name: 'Transport',
  mixins: [Mixin],
  components: {
    Navi,
  },
  created() {
    // 与信不可のユーザはホーム画面に遷移させる
    if (this.isYoshinFuka) return this.$router.push({ name: 'Home' })
  },
}
</script>
<style lang="sass" scoped>
@import '../../assets/css/logico2'
.page-btn-wrapper
  padding-top: 150px
  @include sp
    padding-top: 100px
.md-button
  @include sp
    margin: 6px auto
</style>



// WEBPACK FOOTER //
// src/components/order/Index.vue